<template>
  <DashboardHero :loading="loading">
    <template v-slot:title>Yield:</template>
    <template v-slot:value>
      <el-popover
        placement="top-start"
        title="Yield"
        width="200"
        trigger="hover"
        :content="data.info"
      >
        <div slot="reference" style="display: inline !important">
          {{ (data.yield || 0) | currencySign($root.state.facilityData) }} /SF
        </div>
      </el-popover>
    </template>
  </DashboardHero>
</template>

<script>
import axios from 'axios';
import DashboardHero from './DashboardHero';
import { UNITS_API_BASE } from '../env';

export default {
  name: 'FacilityYield',
  props: {
    facility: { type: String, required: true },
  },
  components: { DashboardHero },
  watch: {
    async facility() {
      this.loading = true;
      await this.getFacilityYield();
      this.loading = false;
    },
  },
  async mounted() {
    if (!this.facility) {
      return;
    }

    await this.getFacilityYield();
    this.loading = false;
  },
  data() {
    return {
      loading: true,
      data: { yield: 0 },
    };
  },
  methods: {
    async getFacilityYield() {
      try {
        const response = await axios.get(`${UNITS_API_BASE}/dashboard/yield/${this.facility}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        const data = response.data.result;

        this.data = data;
      } catch (err) {
        this.$message({
          showClose: true,
          offset: 60,
          type: 'error',
          duration: 10000,
          message: err.response.data,
        });
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/FacilityYield.vue